var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oauth-page"},[_c('div',{staticClass:"oauth-page__card"},[_c('i',{staticClass:"mdi mdi-loading mdi-spin"}),_c('p',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }